import { m } from "framer-motion";

import { Box, Grid, Stack, Button, useTheme, Skeleton, Typography, LinearProgress } from "@mui/material";

import Iconify from "src/components/iconify";

import { useMyInterestQuiz } from "./my-interest-quiz.hook";

interface MyInterestQuizProps {
    sendingMyInterests: any
    handleCloseDialog: () => void;
}

export default function MyInterestQuiz({ sendingMyInterests, handleCloseDialog }: MyInterestQuizProps) {
    const {
        question,
        isInterestSelected,
        quizProgress,
        isLoadingQuestions,
        handleSelectInterest,
        handleNextQuestion,
    } = useMyInterestQuiz(sendingMyInterests)

    const theme = useTheme()

    return (
        <>
            <Stack bgcolor='primary.darker' color='white' height='calc(100vh - 72px)'>
                <Stack py={12} px={12} bgcolor='greenBrand.0' color='primary.darker'>
                    <Stack alignSelf='flex-end'>
                        <Button
                            sx={{
                                maxWidth: 'fit-content',
                                borderRadius: 10,
                                px: 0,
                                py: "0px !important",
                                flex: 0
                            }}
                            onClick={handleCloseDialog}
                            disableRipple
                        >
                            <Stack direction='row' alignItems='center' spacing={1}>
                                <Typography variant='inputXS700' fontWeight='normal'>
                                    Fechar
                                </Typography>
                                <Iconify icon='ri:close-fill' />
                            </Stack>
                        </Button>
                    </Stack>
                    <Box height={32} />
                    {
                        isLoadingQuestions.value ?
                            <Skeleton width='70%' sx={{ bgcolor: 'grey.100' }} />
                            :
                            <Typography variant="h6">
                                {question?.question}
                            </Typography>
                    }
                </Stack>
                <Stack bgcolor='#fff' px={12} flex={1} overflow='auto' pb={24} spacing={8}>
                    <Stack py={10}>
                        <LinearProgress
                            value={isLoadingQuestions.value ? 0 : quizProgress}
                            variant="determinate"
                            sx={{
                                height: 15,
                                bgcolor: theme.palette.grey[200],
                                '& .MuiLinearProgress-bar': {
                                    bgcolor: theme.palette.blueBrand[400],
                                },
                                borderRadius: 4,
                            }}
                        />
                    </Stack>
                    {
                        isLoadingQuestions.value ?
                            <>
                                <Stack>
                                    <Skeleton width='200px' sx={{ bgcolor: 'grey.100' }} />
                                </Stack>
                                <Stack>
                                    <Grid container spacing={4}>
                                        {Array.from({ length: 6 }).map((_, i) => (
                                            <Grid item xs={6} key={i}>
                                                <Stack spacing={2}>
                                                    <Skeleton
                                                        variant="rectangular"
                                                        width="100%"
                                                        height={200}
                                                        sx={{ bgcolor: 'grey.100', borderRadius: 1 }}
                                                    />
                                                </Stack>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </Stack>
                            </>
                            :
                            <>
                                <Stack p={4} bgcolor='blueBrand.0' color='primary.darker' width='fit-content' borderRadius={1}>
                                    <Typography variant="inputXS500">Escolha apenas uma opção</Typography>
                                </Stack>
                                <Grid container columnSpacing={8} rowSpacing={4}>
                                    {question?.options?.map((interest) => (
                                        <Grid item xs={6} key={interest.id}>
                                            <m.div
                                                initial={{ opacity: 0, y: -20 }}
                                                animate={{ opacity: 1, y: 0 }}
                                                transition={{ duration: 0.5, ease: "easeOut", delay: 0.2 }}
                                                style={{ height: '100%' }}
                                            >
                                                <Stack
                                                    spacing={2}
                                                    height='100%'
                                                    onClick={() => handleSelectInterest(interest.id)}
                                                >
                                                    <Box
                                                        component='img'
                                                        sx={{
                                                            aspectRatio: '1.2 / 1',
                                                        }}
                                                        borderRadius='4px 4px 0px 0px'
                                                        src={interest.image} />
                                                    <Stack
                                                        px={4}
                                                        py={7}
                                                        justifyContent='center'
                                                        sx={{ transition: '0.3s' }}
                                                        bgcolor={isInterestSelected === interest.id ? 'greenBrand.0' : '#D9D9D9'}
                                                        borderRadius='0px 0px 4px 4px'
                                                        flex={1}
                                                    >
                                                        <Typography variant="inputXS500" color='black'>
                                                            {interest.name}
                                                        </Typography>
                                                    </Stack>
                                                </Stack>
                                            </m.div>
                                        </Grid>
                                    ))}
                                </Grid>
                            </>
                    }
                </Stack>
            </Stack>
            <Button
                sx={{
                    py: 18,
                    alignItems: 'center',
                    gap: 4,
                    borderRadius: 0
                }}
                variant="contained"
                color="primary"
                onClick={handleNextQuestion}
                disabled={!isInterestSelected}
            >
                {quizProgress === 100 ? 'Finalizar' : 'Próximo'}
            </Button>
        </>
    )
}